const map = {
	"./de-DE.json": [
		8017,
		[
			17
		]
	],
	"./es-ES.json": [
		97563,
		[
			563
		]
	],
	"./fr-FR.json": [
		91155,
		[
			155
		]
	],
	"./it-IT.json": [
		83689,
		[
			689
		]
	],
	"./pt-BR.json": [
		23867,
		[
			867
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 12153;
module.exports = webpackAsyncContext;